<template>
  <div class="container">
    <div class="apply-tab">
      <img @click="handleBack" style="width: 24px; height: 24px" src="@/assets/back.png" />
      <div>人员选择</div>
    </div>
    <div class="department_list">
      <div class="header" v-if="currentType === 1">
        <div class="logo">
          <img v-if="data.companyLogo" :src="data.companyLogo" />
          <img v-else src="@/assets/logo.svg" />
        </div>
        <div class="header_title">{{ data.companyName }}</div>
      </div>
      <div v-for="(item, index) in list" :key="index" class="item" @click="handleClick(item)">
        <div class="item_text">
          <van-checkbox v-if="item.staffId" v-model="item.isChecked" @click="changeCheckBox(item)" shape="square"></van-checkbox>
          <span style="margin-left: 16px" v-if="item.officeName">{{ item.officeName }}</span>
          <span v-if="!item.staffId">（{{ item.totalCount }}）</span>
          <span style="margin-left: 16px" v-if="item.staffId">{{ item.staffName }}</span>
        </div>
        <i v-if="item.type != 2" class="iconfont icon-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { getCompanyAddressList } from '@/axios/services';
import { Toast } from 'vant';
export default {
  data() {
    return {
      isOnwerCompany: false,
      list: [],
      historyList: [],
      data: {},
      currentType: 1
    };
  },
  computed: {
    ...mapState(['initialData', 'selectedList', 'status'])
  },
  methods: {
    ...mapMutations(['setSelectList']),
    getCompanyAddressList() {
      const params = {
        companyId: this.$route.query?.companyId,
        queryType: 1
      };
      getCompanyAddressList(params).then(res => {
        if (res.data.code === 0) {
          this.list = res.data.data.childrenList.map(item => {
            if (item.staffId) {
              return { ...item, id: item.staffId };
            } else {
              return { ...item };
            }
          });
          this.list.forEach(item => {
            if (this.selectedList[`${this.status}`] && this.selectedList[`${this.status}`].length > 0) {
              this.selectedList[`${this.status}`].forEach(i => {
                if (item.staffId && item.staffId === i.staffId) {
                  item.isChecked = true;
                }
              });
            }
          });
          console.log(this.list);
          this.data = res.data.data;
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
    handleClick(item) {
      if (item.childrenList && item.childrenList.length > 0) {
        this.currentType++;
        this.historyList = JSON.parse(JSON.stringify(this.list));
        this.list = item.childrenList.map(item => {
          if (item.staffId) {
            return { ...item, id: item.staffId };
          } else {
            return { ...item };
          }
        });
        this.list.forEach(item => {
          if (this.selectedList[`${this.status}`] && this.selectedList[`${this.status}`].length > 0) {
            this.selectedList[`${this.status}`].forEach(i => {
              if (item.staffId && item.staffId === i.staffId) {
                item.isChecked = true;
              }
            });
          }
        });
      }
    },
    changeCheckBox(item) {
      !item.isChecked;
      this.setSelectList(item);
      this.$forceUpdate();
      this.$parent.$forceUpdate();
    },
    back() {
      if (this.currentType === 1) {
        this.$router.back();
      } else {
        this.currentType--;
        this.list = this.historyList;
      }
    },
    handleBack() {
      if (this.currentType === 1) {
        this.$router.back();
      } else {
        this.currentType--;
        this.list = this.historyList;
      }
    }
  },
  created() {
    this.getCompanyAddressList();
  },
  mounted() {
    //挂载成功后给pop事件绑定一个方法
    // 如果支持 popstate （一般移动端都支持）
    if (window.history && window.history.pushState) {
      // 往历史记录里面添加一条新的当前页面的url
      history.pushState(null, null, document.URL);
      // 给 popstate 绑定一个方法用来监听页面返回
      window.addEventListener('popstate', this.back, false); //false阻止默认事件
    }
  },
  //组件销毁后清除事件
  destroyed() {
    window.removeEventListener('popstate', this.back, false); //false阻止默认事件
  }
};
</script>

<style lang="less" scoped>
.container {
  padding-top: 64px;
  .apply-tab {
    width: 100%;
    height: 64px;
    background: #ffffff;
    position: fixed;
    z-index: 99;
    padding-left: 10px;
    line-height: 64px;
    top: 0;
    left: 0;
    div {
      font-size: 0.48rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .department_list {
    width: 343px;
    background-color: #ffffff;
    border-radius: 4px;
    padding: 10px 16px;
    margin: 16px auto;
    margin-bottom: 68px;
    .header {
      height: 64px;
      display: flex;
      align-items: center;
      .logo {
        width: 50px;
        height: 50px;
        background-color: #ffffff;
        border: 1px solid;
        border-color: #e6e6e6;
        border-radius: 20px;
        overflow: hidden;
        padding: 10px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .header_title {
        margin-left: 10px;
        font-family: Source Han Sans CN;
        font-weight: 700;
        color: #333333;
        font-size: 14px;
      }
    }
    .item {
      margin-left: 10px;
      height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #f3f3f3;
      .item_text {
        font-family: Source Han Sans CN;
        color: #333333;
        font-size: 14px;
        display: flex;
      }
    }
  }
}
</style>
